export const I18N = {
  CHANGE_LOCALE: "I18N_CHANGE_LOCALE",
  CHANGE_LOCALE_DONE: "I18N_CHANGE_LOCALE_DONE",
  CHANGE_LOCALE_FAILED: "I18N_CHANGE_LOCALE_FAILED",
  LOAD: "I18N_LOAD",
  LOAD_DONE: "I18N_LOAD_DONE",
  LOAD_FAILED: "I18N_LOAD_FAILED",
  LOAD_LOCALES: "I18N_LOAD_LOCALES",
  LOAD_LOCALES_DONE: "I18N_LOAD_LOCALES_DONE",
  LOAD_LOCALES_FAILED: "I18N_LOAD_LOCALES_FAILED",
};

export const changeLocale = locale => ({ type: I18N.CHANGE_LOCALE, locale });
export const load = () => ({ type: I18N.LOAD });
export const loadLocales = () => ({ type: I18N.LOAD_LOCALES });



// WEBPACK FOOTER //
// ./src/actions/i18n.js